import AppLayout from "./AppLayout";
import {Provider} from 'react-redux'
import { store, persistor } from "./store";
import AuthProvider from "./page/auth/AuthProvider/AuthProvider";
import {BrowserRouter as Router} from 'react-router-dom';
import {QueryClient, QueryClientProvider} from "react-query";
import {I18nextProvider} from "react-i18next";
import i18n from './localization/i18n';
import {PersistGate} from "redux-persist/integration/react";
import {LanguageListener} from "./components";
import { Helmet, HelmetProvider } from "react-helmet-async";


function App() {
  const queryCLient = new QueryClient()

  return (
      <QueryClientProvider client={queryCLient}>
          <I18nextProvider i18n={i18n}>
              <Provider store={store}>
                  <PersistGate loading={null} persistor={persistor}>
                      <Router>
                          <AuthProvider>
                              <HelmetProvider>
                                  <Helmet>
                                      <title>Avtoustoz</title>
                                      <meta
                                          name="description"
                                          content="Avtoustoz o'quv markazini online test dasturi"
                                      />
                                      <link rel="icon" type="image/png" href="/Logo_.png" />
                                      <meta name="author" content="Bobur Berdiev" />
                                  </Helmet>

                                  <AppLayout />
                                  <LanguageListener />
                              </HelmetProvider>
                          </AuthProvider>
                      </Router>
                  </PersistGate>
              </Provider>
          </I18nextProvider>
      </QueryClientProvider>
  );
}
export default App;
